import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { environment } from '../../../environments/environment';
import { AuthenticationService } from "../../views/authentication/authentication.service";

@Injectable()
export class AppChartContractLinesService {

  @Output() filterData: EventEmitter<any> = new EventEmitter();
  @Output() selectedFilter: any = {};
  constructor(private http: HttpClient, private authService: AuthenticationService) { }

  setFilterData(filter){
    this.selectedFilter = filter;
    this.filterData.emit(filter);
    console.info(this.selectedFilter);
  }

  getHeaders(): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.authService.token);
    return headers;
  }

  getRenewalLines() {
    return this.http.get(environment.API + '/dashboard/get-renewal-lines-period/', { headers: this.getHeaders() })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/app-chart-contract-lines/app-chart-contract-lines.service.ts